import { isOptionalTypeNode } from 'typescript'
import { OptionType } from '../types'

export const mainColors = [
  '#2BBA47',
  '#A547D2',
  '#FFA11D',
  '#EC1A3C',
  '#49A2FF',
  '#6342D2',
  '#FD46D5',
]
export const colorsPalette = [
  '#B71C1C',
  '#880E4F',
  '#4A148C',
  '#194185',
  '#006064',
  '#33691E',
  '#F57F17',
  '#E65100',
  '#3E2723',
  '#C62828',
  '#AD1457',
  '#6A1B9A',
  '#1849A9',
  '#00838F',
  '#558B2F',
  '#F9A825',
  '#EF6C00',
  '#4E342E',
  '#D32F2F',
  '#C2185B',
  '#7B1FA2',
  '#175CD3',
  '#0097A7',
  '#689F38',
  '#FBC02D',
  '#F57C00',
  '#5D4037',
  '#E53935',
  '#D81B60',
  '#8E24AA',
  '#1570EF',
  '#00ACC1',
  '#7CB342',
  '#FDD835',
  '#FB8C00',
  '#6D4C41',
  '#E35141',
  '#E91E63',
  '#9C27B0',
  '#2E90FA',
  '#00BCD4',
  '#8BC34A',
  '#FFEB3B',
  '#FF9800',
  '#795548',
  '#EF5350',
  '#EC407A',
  '#AB47BC',
  '#53B1FD',
  '#26C6DA',
  '#9CCC65',
  '#FFEE58',
  '#FFA726',
  '#8D6E63',
  '#E57373',
  '#F06292',
  '#BA68C8',
  '#84CAFF',
  '#4DD0E1',
  '#AED581',
  '#FFF176',
  '#FFB74D',
  '#A1887F',
]
export const superAdminOptions: OptionType[] = [
  { id: 1, title: 'Главная' },
  { id: 2, title: 'Администраторы' },
  { id: 3, title: 'Компании' },
  { id: 4, title: 'Залы' },
  { id: 5, title: 'Заявки' },
  { id: 6, title: 'Запросы на регистрацию' },
  { id: 7, title: 'Площадки' },
  { id: 8, title: 'Меню' },
  { id: 9, title: 'Отчеты' },
  { id: 10, title: 'Клиенты' },
]
export const adminOptions: OptionType[] = [
  { id: 1, title: 'Главная' },
  { id: 2, title: 'Компании' },
  { id: 3, title: 'Залы' },
  { id: 4, title: 'Заявки' },
  { id: 5, title: 'Запросы на регистрацию' },
  { id: 6, title: 'Площадки' },
  { id: 7, title: 'Меню' },
  { id: 8, title: 'Отчеты' },
  { id: 9, title: 'Клиенты' },
]
export const directorAgentOptions: OptionType[] = [
  { id: 1, title: 'Главная' },
  { id: 2, title: 'Профиль' },
  { id: 3, title: 'Залы' },
  { id: 4, title: 'Площадки' },
  { id: 5, title: 'Меню' },
  { id: 6, title: 'Отчеты' },
  { id: 7, title: 'Клиенты' },
]
export const agentOptions: OptionType[] = [
  { id: 1, title: 'Главная' },
  { id: 2, title: 'Заявки' },
  { id: 3, title: 'Профиль' },
  { id: 4, title: 'Меню' },
  { id: 5, title: 'Отчеты' },
  { id: 6, title: 'Клиенты' },
]
export const platformOptions: OptionType[] = [
  { id: 1, title: 'Главная' },
  { id: 2, title: 'Профиль' },
  { id: 3, title: 'Залы' },
  { id: 4, title: 'Меню' },
  { id: 5, title: 'Отчеты' },
  { id: 6, title: 'Клиенты' },
]

export const monthsArr = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const placesPerPage = 16
export const companiesPerPage = 10
export const adminsPerPage = 10
export const staffPerPage = 10
export const requestsPerPage = 10
export const establishmentsPerPage = 16
export const categoriesPerPage = 100
export const menuPerPage = 100
export const productPerPage = 100

export const adminFilters = ['Все', 'Суперадминистратор', 'Администратор']
export const companiesFilters = ['Все', 'Агент', 'Зал']
export const staffAgentFilters = ['Все', 'Директор-Агент', 'Агент']
export const staffPlacesFilters = ['Все', 'Директор-Зал', 'Зал']
export const claimsFilters = ['Все', 'Завершенные', 'В работе', 'Отклонены']
export const registrationRequestFilters = ['Все', 'В ожидании', 'Отклонены', 'Приняты']

export const claimsStatuses = [
  'В работе',
  'Завершена',
  'Отменена',
  'Потверждён',
  'Предварительная бронь',
  'Отклонена',
  'Не подтверждена',
]

export const paymentType = ['Оплата по счету', 'Оплата наличными', 'Бартер', 'Сертификат']

export const rejectionCauses = [
  'Отменили мероприятие',
  'Перенос мероприятия',
  'Высокая стоимость',
  'Выбрана другая площадка',
  'Интерьер',
  'Оснащение',
  'Неудобная локация',
]

export const paymentStatus = ['Оплачено', 'Не оплачено', 'Частично оплачено', 'Комплиментарно']

export const claimStatusesFromBack: Record<string, string> = {
  inProgress: 'В работе',
  accepted: 'Завершенные',
  rejected: 'Отменена',
  confirmed: 'Потверждён',
  canceled: 'Отклонена',
  unconfirmed: 'Не подтверждена',
  inAnticipation: 'Предварительная бронь',
}

export const otherCategories = ['Напитки', 'Аренда оборудования', 'Дополнительные услуги']

export const segments = [
  'Конференции',
  'Банкеты',
  'Спортивная группа',
  'Свадьбы',
  'Выпускные',
  'Бизнес-завтраки',
  'Активности для гостей отеля',
]

export const discountType = ['В процентах', 'В рублях']

// Menu
export const menuItems: OptionType[] = [
  { id: 1, title: 'Холодные закуски' },
  { id: 2, title: 'Горячие закуски' },
  { id: 3, title: 'Салаты' },
  { id: 4, title: 'Горячие блюда' },
  { id: 5, title: 'Блюда на гриле' },
  { id: 6, title: 'Гарниры' },
  { id: 7, title: 'Напитки' },
  { id: 8, title: 'Соусы' },
]

export const arrangementTypes = [
  'Театр',
  'Класс',
  'Круглые столы',
  'Общий стол',
  'Буквой П',
  'Пустой зал',
  'Чистый зал',
]

export const eventsList = [
  'Застройка',
  'Фуршет',
  'Банкет',
  'Подача горячей закуски',
  'Подача горячего блюда',
  'Подача торта',
]

export const measurementUnits = [
  'гр',
  'кг',
  'мг',
  'л',
  'мл',
  'штука',
  'упаковка',
  'коробка',
  'банка',
  'бутылка',
  'пачка',
  'стакан',
  'ложка',
  'чайная ложка',
  'столовая ложка',
  'кусок',
  'порция',
  'часы',
]
